/* Domovoi · the signed-in session, read without the Supabase SDK.

   The one place outside supabase-js that touches the stored token. Pages
   that only need "who is this?" read it here instead of loading ~200KB of SDK. */
import { AUTH_STORAGE_KEY } from './config.js';
import { storage } from './storage.js';

export function stored() {
  try {
    var raw = storage.get(AUTH_STORAGE_KEY);
    if (!raw) return null;
    var data = JSON.parse(raw);
    var s = (data && data.access_token) ? data : (data && data.session) ? data.session : null;
    return (s && s.access_token) ? s : null;
  } catch (e) { return null; }
}

/* Signed in = a stored session we can still renew. The access token inside
   lasts an hour, but the refresh token lasts until you sign out, and every
   page with the SDK (Catered, Curated, the homepage hub) renews it silently.
   So an hour-old token is not "signed out" — it used to be treated as one,
   which showed "Sign in" to anyone who'd been away for an hour. */
export function session() {
  var s = stored();
  if (!s) return null;
  if (s.expires_at && s.expires_at < Date.now() / 1000 && !s.refresh_token) return null;
  return s;
}

/* A token that's still valid right now, for direct REST calls. This file
   never renews tokens itself: refresh tokens rotate, and renewing here while
   an SDK page in another tab does the same could get the session revoked. */
export function live() {
  var s = stored();
  if (!s) return null;
  if (s.expires_at && s.expires_at < Date.now() / 1000 + 30) return null;
  return s;
}

/* Email + id straight out of the JWT, so the menu is never blank. */
export function fromToken(s) {
  try {
    var body = JSON.parse(atob(s.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return { id: body.sub || null, email: body.email || null };
  } catch (e) { return { id: null, email: null }; }
}

/* The access token, if it is still valid for a direct REST call. */
export function accessToken() {
  var s = live();
  return s ? s.access_token : null;
}
